import React from "react";

interface TagFilterProps {
    tags: string[];
    selectedTag: string | null;
    onTagSelect: (tag: string | null) => void;
}

const TagFilter: React.FC<TagFilterProps> = ({ tags, selectedTag, onTagSelect }) => {
    return (
        <div className="flex flex-wrap gap-2 mb-8">
            <button
                onClick={() => onTagSelect(null)}
                className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-colors duration-300 ${selectedTag === null
                        ? "bg-terminal-text text-terminal-background"
                        : "bg-terminal-subtle text-terminal-accent hover:bg-terminal-text hover:text-terminal-background"
                    }`}
            >
                All
            </button>
            {tags.map((tag) => (
                <button
                    key={tag}
                    onClick={() => onTagSelect(tag)}
                    className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-colors duration-300 ${selectedTag === tag
                            ? "bg-terminal-text text-terminal-background"
                            : "bg-terminal-subtle text-terminal-accent hover:bg-terminal-text hover:text-terminal-background"
                        }`}
                >
                    {tag}
                </button>
            ))}
        </div>
    );
};

export default TagFilter;
